import React, { useEffect, useState } from "react";
import { getDomains, deleteDomain } from "../../api/sousdomaines";

export default function SousDomainsList({ onEdit }) {

  const [domains, setDomains] = useState([]);
  const [view, setView] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const loadDomains = async (url) => {
    const data = await getDomains(url);

    setDomains(data.items);
    setView(data.view);

    // ➜ extrait le numéro de page depuis hydra:view["@id"]
    if (data.view && data.view["@id"]) {
      const match = data.view["@id"].match(/page=(\d+)/);
      if (match) setCurrentPage(parseInt(match[1], 10));
    }
  };

  useEffect(() => {
    loadDomains(); // page 1 par défaut
  }, []);

  const goTo = (url) => {
    loadDomains("http://localhost:8080" + url);
  };

  // ➜ constrution des pages autour
  const pages = [
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
  ].filter(p => p > 0); // pas de pages 0 ou négatives

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer cette Suggestion ?")) {
      await deleteDomain(id);
      loadDomains();
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>Gestion des sous-domaines</h2>
        <button className="fr-btn">+ Créer</button>
      </div>

      <p className="admin-page-count">
        {domains.length} sous-domaine{domains.length > 1 ? "s" : ""}
      </p>

      <div className="table-responsive">
        <table className="table table-vcenter" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
          <tr style={{ borderBottom: "1px solid #e2e8f0" }}>
            <th className="admin-table-th">Domaine</th>
            <th className="admin-table-th">Fiches</th>
            <th className="admin-table-th"></th>
          </tr>
          </thead>

          <tbody>
          {domains.map((d) => (
            <tr key={d.ssd.ssdId} className="admin-table-row">
              <td className="admin-table-td">
                <a href={`/domains/${d.dom.domId}`} className="admin-link">{d.dom.domLib}</a>
              </td>
              <td className="admin-table-td">{d.ssd.ssdLib}</td>
              <td className="admin-table-td" style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                <button className="fr-btn--secondary" onClick={() => onEdit(d)} style={{ marginRight: 8 }}>Modifier</button>
                <button className="fr-btn--danger" onClick={() => handleDelete(d.ssd.ssdId)}>Supprimer</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION HYDRA */}
      <div style={{ marginTop: 16 }}>
        <button
          className="fr-btn--secondary"
          disabled={!view?.["hydra:previous"]}
          onClick={() => goTo(view["hydra:previous"])}
        >
          ◀ Précédent
        </button>
        {/* pages -2 -1 0 +1 +2 */}
        {pages.map(p => (
          <button
            key={p}
            onClick={() => goTo(`/api/suggestions?page=${p}`)}
            style={{
              fontWeight: p === currentPage ? "bold" : "normal",
              textDecoration: p === currentPage ? "underline" : "none",
              margin: 4
            }}
          >
            {p}
          </button>
        ))}
        <button
          className="fr-btn--secondary"
          disabled={!view?.["hydra:next"]}
          onClick={() => goTo(view["hydra:next"])}
        >
          Suivant ▶
        </button>
      </div>
    </div>
  );
}
